import { Input } from "./Input";

export class Radio extends Input {
    protected initialize(data: any) {
        super.initialize(data);
        this.setAttribute("type", "radio");
    }
}
